namespace $ {
	
	export class $rise_rpc_ws extends $rise_rpc {
		
		uri() {
			return new URL( '/rise/rpc/', this.$.$mol_dom_context.location.href ).toString()
				.replace( /^http/, 'ws' )
		}
		
		protocol() {
			return 'rise-rpc'
		}
		
		protected queue = [] as $rise_rpc_message[]
		
		@ $mol_mem
		socket() {
			
			const socket = new this.$.$mol_dom_context.WebSocket( this.uri(), this.protocol() )
			
			socket.addEventListener( 'open', ()=> this.flush() )
			
			socket.addEventListener( 'message', event => {
				try {
					this.receive_async( JSON.parse( String( event.data ) ) )
				} catch( error ) {
					this.$.$mol_fail_log( error )
				}
			} )
			
			socket.addEventListener( 'error', ()=> {
				this.abort( new Error( `RPC socket error: ${ this.uri() }` ) )
			} )
			
			socket.addEventListener( 'close', ()=> {
				this.abort( new Error( `RPC socket closed: ${ this.uri() }` ) )
			} )
			
			return Object.assign( socket, {
				destructor: ()=> socket.close(),
			} )
		}
		
		override target() {
			return {
				send: ( message: $rise_rpc_message )=> {
					const socket = this.socket()
					if( socket.readyState !== socket.OPEN ) {
						this.queue.push( message )
						return
					}
					socket.send( JSON.stringify( message ) )
				},
			}
		}
		
		protected override transport_touch() {
			this.socket()
		}
		
		flush() {
			const queue = this.queue.splice( 0 )
			for( const message of queue ) this.target().send( message )
		}
		
	}
	
}
